import { useEffect } from "react";
import Lenis from "lenis";
import { AnimatePresence, motion } from "framer-motion";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Welcome from "@/pages/Welcome";
import About from "@/pages/About";
import Books from "@/pages/Books";
import BookDetail from "@/pages/BookDetail";
import Game from "@/pages/Game";
import Playlist from "@/pages/Playlist";
import Contact from "@/pages/Contact";
import { Toaster } from "@/components/ui/sonner";

const SmoothScroll = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true, wheelMultiplier: 0.85 });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const AnimatedRoutes = () => {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.main
        key={location.pathname}
        initial={{ opacity: 0, y: 18 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -14 }}
        transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Welcome />} />
          <Route path="/about" element={<About />} />
          <Route path="/books" element={<Books />} />
          <Route path="/books/:slug" element={<BookDetail />} />
          <Route path="/game" element={<Game />} />
          <Route path="/playlist" element={<Playlist />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </motion.main>
    </AnimatePresence>
  );
};

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll />
      <ScrollToTop />
      <div className="App grain min-h-screen overflow-x-clip bg-background text-foreground">
        <Navbar />
        <AnimatedRoutes />
        <Footer />
        <Toaster richColors closeButton position="bottom-right" />
      </div>
    </BrowserRouter>
  );
}

export default App;
